import { Injectable } from '@angular/core'
import * as Color from 'color'

@Injectable({
  providedIn: 'root',
})
export class GbColorService {
  public darkText = '#000000DE'
  public lightText = '#FFFFFFDE'

  /**
   * Gets the contast to a given colour
   * @param inputColor colour to get the contast to
   **/

  getContrast(inputColor: string): string {
    const color = Color(inputColor)
    return color.isLight() ? this.darkText : this.lightText
  }
  /**
   * Returns if the colors are contrasting
   **/

  isContrasting(color1: string, color2: string): boolean {
    if (!color1 || !color2) {
      return false
    }
    const firstColor = Color(color1)
    const secondColor = Color(color2)

    return (firstColor.isLight() && secondColor.isDark()) || (firstColor.isDark() && secondColor.isLight())
  }
}
